@if ((viewModel$ | async); as vm) {
  @if (vm.hasChapters) {
    <cm-chapter-topics [isReadonly]="vm.isReadonly"></cm-chapter-topics>
  } @else {
    <cm-project-level-topics [isReadonly]="vm.isReadonly"></cm-project-level-topics>
  }
}